module.exports = __webpack_public_path__ + "img/2026-1.ee966c26.jpg";